function fetchUserStatusSelector(
    state: sage.state.IRedux
): "loading" | "error" | "none" {
    return state.user.fetchUserStatus;
}

export default fetchUserStatusSelector;
